<div class="rx-viewport"
     [class.zoomed]="scale > 1"
     [class.panning]="scale > 1"
     (wheel)="onWheel($event)"
     (mousedown)="onMouseDown($event)"
     (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp()"
     (mouseleave)="onMouseUp()">
  <img *ngIf="image" [src]="thumbnail(image)" [style.transform]="transform" draggable="false">
</div>
